
import React from "react";

interface TickerContentProps {
  messages: string[];
  textColor: string;
  speed?: number;
}

export const TickerContent = React.memo(({ messages, textColor, speed = 20 }: TickerContentProps) => {
  if (!messages.length) return null;

  // Convert speed (in seconds) to CSS variable - ensure it's actually used
  const tickerSpeed = `${speed}s`;
  console.log('TickerContent applying speed:', tickerSpeed);

  return (
    <div 
      className="ticker-container"
      style={{ 
        '--ticker-speed': tickerSpeed
      } as React.CSSProperties}
    >
      <div className="ticker-wrapper">
        {[...Array(3)].map((_, copyIndex) => (
          <div 
            key={`track-${copyIndex}`} 
            className="ticker-track"
            style={{ 
              animationDuration: tickerSpeed
            }}
          >
            {messages.map((message, index) => (
              <span 
                key={`${copyIndex}-${index}-${message}`}
                className="ticker-item text-[18px]"
                style={{ 
                  color: textColor,
                  borderColor: `${textColor}40`
                }}
              >
                {message}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
});

TickerContent.displayName = 'TickerContent';
